import {
  COSCHEDULE,
  HPLUZ,
  JUNION,
  MEESHO,
  MYFITNESSPAL,
  ROYALENFIELD,
  SEPHORA,
  YARDERP1,
} from "../assets";

export const projects = [
  {
    img: YARDERP1,
    title: "Customization ERP Solutions ",
    des: "Managed services to onboard content, integrated web conferencing tool to conduct online classes, assessments and automated evaluation, teacher and student/parent login, online course content to track student progress.",
    demo: "",
    live: "https://www.yarderp.com/",
    gitHub: "https://github.com/sunilbrown89/YardErp-Mine-",
    technologies: [
      "Tailwind Css",
      "NextJs",
      "Typescript",
      "Mongoose",
      "Express",
      "MongoDB",
      "Node Js",
      "AWS",
    ],
  },
  {
    img: JUNION,
    title: "GlobalED Leads Platform",
    des: "Streamlined international student recruitment processes,empowering universities to drive global enrollment growth.",
    demo: "",
    live: "https://www.iamjunion.com/",
    gitHub: "https://github.com/sunilbrown89/iamjunion-next-web",
    technologies: [
      "ReactJs/NextJs ",
      "Javascript",
      "Mongoose",
      "Express",
      "SWR",
      "Node Js",
      "AWS",
      "Zustand",
      "Stripe Integration",
    ],
  },
  {
    img: HPLUZ,
    title: "Hpluz - Medical Services",
    des: "To encourage and elevate transparency in the functioning of the pharmaceutical industry, Hpluz has been successfully contributing in providing genuine and unadulterated medicines since its inception.",
    demo: "",
    live: "https://hplus-admin.vercel.app/",
    gitHub: "https://github.com/sunilbrown89/hpluz-admin",
    technologies: [
      "Tailwind CSS",
      "Typescript",
      "Firebase",
      "MongoDB",
      "Express",
      "Payment Gateway",
    ],
  },
  // {
  //   img: MYFITNESSPAL,
  //   title: "MTFITNESSPAL.COM",
  //   des: "MyFitnessPal is a smartphone app and website that tracks diet and exercise. The app uses gamification elements to encourage adherence to exercise and diet goals.",
  //   demo: "",
  //   live: "https://myfitnesspal-clone.netlify.app/",
  //   gitHub: "https://github.com/rajashree27/MyFitnessPal-Clone",
  //   technologies: [
  //     "React Js ",
  //     "Javascript",
  //     "Mongoose",
  //     "Express",
  //     "React Redux",
  //     "Node Js",
  //   ],
  // },
  // {
  //   img: MEESHO,
  //   title: "MEESHO",
  //   des: "Meesho is a social E-commerce platform that undertakes retail distribution, enabling small retail merchants to connect and sell their products effectively via social media channels.",
  //   demo: "",
  //   live: "https://meeshoecom.netlify.app/",
  //   gitHub: "https://github.com/prakash817/meesho",
  //   technologies: [
  //     "HTML",
  //     "CSS",
  //     "JavaScript",
  //     "Advance JS",
  //     "Localstorage",
  //     "Bootstrap",
  //   ],
  // },
  {
    img: COSCHEDULE,
    title: "COSCHEDULE.COM",
    des: "A calendar website that helps you see, schedule, and share your marketing.",
    demo: "",
    live: "https://cosch.netlify.app/",
    gitHub: "https://github.com/Shreyansh051/Coschedule-Clone",
    technologies: [
      "CSS",
      "Redux",
      "ReactJs",
      "Express",
      "MongoDB",
      "Node Js",
      "chakra UI",
    ],
  },
  {
    img: SEPHORA,
    title: "SEPHORA NNNOW.COM",
    des: "Sephora is a French multinational retailer of personal care and beauty products.Along with its own private label, Sephora Collection, Sephora offers beauty products including cosmetics, skincare, body, fragrance, nail color, beauty tools, body lotions and haircare.",
    demo: "",
    live: "https://fascinating-lily-608479.netlify.app/",
    gitHub: "https://github.com/Saradhii/Sephora-nnnow.com-clone",
    technologies: [
      "HTML",
      "CSS",
      "JavaScript",
      "React",
      "Advance React",
      "Bootstrap",
      "Mongoose",
      "MongoDB",
    ],
  },

  {
    img: ROYALENFIELD,
    title: "ROYAL ENFIELD",
    des: "Royal Enfield is an Indian motorcycle manufacturing company, popularly known for its Royal Enfield Bullet series of bikes. It is one of the oldest motorcycle manufacturing companies in the global world.",
    demo: "",
    live: "https://royalenfieldclone.netlify.app/",
    gitHub: "https://github.com/SUMAN-24/Royal-Enfield",
    technologies: ["HTML", "CSS", "JavaScript", "API", "Bootstrap"],
  },
];
